import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import * as moment_tz from 'moment-timezone';
import { CONFIG } from '../../common/config';
import { AuthenticationService } from '../../service/authentication.service';
import { ContextService } from '../../service/context.service';

@Pipe({ name: 'datetime' })
export class DatetimeFormatterPipe implements PipeTransform {

  constructor(
    @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
    @Inject(forwardRef(() => ContextService)) private contextService: ContextService
  ) { };

  transform(value: any, format?: string, timezone?: string, language?: string): string {
    if (value && value != -1) {
      let tz = timezone || this.getTimezone();
      let f = format ? format : CONFIG.DYNAMIC_DATETIME_FORMAT;
      const locale = language || this.getLocale();
      return moment_tz.tz(value, tz).locale(locale).format(f);
    } else {
      return '-';
    }
  }

  private getTimezone(): string {
    if (this.contextService) {
      return this.contextService.getTimezone();
    } else if (this.authenticationService) {
      return this.authenticationService.getUser()?.timezone || ContextService.DEFAULT_TIMEZONE;
    } else {
      return ContextService.DEFAULT_TIMEZONE;
    }
  }

  private getLocale(): string {
    return this.authenticationService?.getLocale() || 'en';
  }
}
